import { render, staticRenderFns } from "./ScratchPlayer.vue?vue&type=template&id=5a2b5474&"
import script from "./ScratchPlayer.vue?vue&type=script&lang=js&"
export * from "./ScratchPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luan/xiaoma/scratch-common-player/node_modules/_vue-hot-reload-api@2.3.3@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2b5474')) {
      api.createRecord('5a2b5474', component.options)
    } else {
      api.reload('5a2b5474', component.options)
    }
    module.hot.accept("./ScratchPlayer.vue?vue&type=template&id=5a2b5474&", function () {
      api.rerender('5a2b5474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "demo/vue/ScratchPlayer.vue"
export default component.exports